(ns ncr.navigate
  (:require
   [clojure.core.match :refer [match]]
   [clojure.core.async :refer-macros [go]]
   [uix.core.alpha :as uix]
   [reitit.frontend.easy :as history]
   [ncr.etc.pubsub :as ps]
   [ncr.etc.profile :as p]))

(def ^:private pspec [:ephemeral "ui/navdepth"])

(defn use-router [routes]
  (let [route (uix/state nil)]
    (uix/with-effect [routes]
      (history/start! routes
        (fn [{:keys [data path-params query-params]} _]
          (reset! route (merge data path-params query-params)))
        {:use-fragment true}))
    @route))

(defn push-state! [& args]
  (go
    (p/swap-profile! pspec 0 inc)
    (apply history/push-state args)))

(defn replace-state! [& args]
  (apply history/replace-state args))

(defn back! []
  (go
    (let [depth (<! (p/read-profile! pspec 0))]
      (if (> depth 0)
        (do
          (.go (.-history js/window) -1)
          (p/swap-profile! pspec 0 dec))
        (ps/pub! [:query/navigate])))))

(def href history/href)

(defn push-search! [query]
  (push-state! :search {:query query}))

(defn search-href [query]
  (href :search {:query query}))

(defn- fragment-route [params]
  (match params
    {:id _ :slug _ :attachment-id _}
    :fragment-slug-attachment

    {:id _ :slug _}
    :fragment-slug

    {:id _}
    :fragment
    _
    (do
      (.warn js/console "Unexpected fragment spec: " params)
      nil)))

(defn push-fragment! [params]
  (when-let [route (fragment-route params)]
    (push-state! route params)))

(defn fragment-href [params]
  (when-let [route (fragment-route params)]
    (href route params)))

